<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div @click="goTitlePage ('Summary')"  class="title d-sm-flex pointer" :class="{'active' : title === 'Summary'}">
            <div class="my-auto">
              課程總覽
            </div>
          </div>
          <div @click="goTitlePage ('Info')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Info'}">
            <div class="my-auto">
              學習紀錄
            </div>
          </div>
          <div @click="goTitlePage ('Curve')" class="title  d-sm-flex pointer" :class="{'active' : title === 'Curve'}">
            <div class="my-auto">
              學習曲線
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-2" style="min-height:40vh">
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <label class="m-0 mr-2">學員姓名:</label>
            <v-select style="width:200px" :clearable="false" v-model="studentId" :reduce="name => name.id" label="name" :options="studentList">
              <span slot="no-options">
                找不到搜尋結果
              </span>
            </v-select>
          </div>
          <!-- <div style="text-align: right;" class="download-btn">
            <button type="button" @click="postReports" class="btn btn-danger">下載報表</button>
          </div> -->
        </div>
        <div class="my-2">
          <div class="d-flex align-items-center">
            <label class="m-0 mr-2">日期區間:</label>
            <date-picker valueType="format" v-model="range" type="date" range placeholder="請選擇日期區間"></date-picker>
          </div>
        </div>
        <!-- <table class="rwd-table">
          <tbody>
            <tr>
              <th>學生姓名</th>
              <th>最近學習日期</th>
              <th>課程通過數</th>
            </tr>
            <tr v-for="(item, index) in studentList" :key="index">
              <td data-th="學生姓名" class="rwd-td" >
                {{item.name}}
              </td>
              <td data-th="最近學習日期">
                {{item.total_times}}
              </td>
              <td data-th="課程通過數" style="text-decoration:underline" class="pointer" @click="goPage(item.student_id)">
                {{item.total_pass_count}}
              </td>
            </tr>
          </tbody>
        </table> -->
        <div>
          <div v-for="(item, index) in recordInfo" :key="index">
            <div class="d-flex">
              <table class="rwd-table">
                <tbody>
                  <tr>
                    <th class="th-title" style="text-align:center; width:350px!important;background-size:cover;" rowspan="2" :style="{ backgroundImage: 'url(' + item.banner + ')' }">
                      <div>
                        {{item.level1}} > {{item.level2}}
                      </div>
                      <h5>{{item.name}}</h5>
                    </th>
                    <th>最近學習時間</th>
                    <th>學習總時數</th>
                    <th>第一次分數</th>
                    <th>口說分數</th>
                    <th>學習次數</th>
                  </tr>
                  <tr>
                    <td class="rwd-td" style="display:none" :data-th="item.name">
                    </td>
                    <td data-th="最近學習時間">
                      {{moment(item.recent).format('YYYY/MM/DD HH:mm:ss') }}
                    </td>
                    <td data-th="學習總時數">
                      {{item.time}}
                    </td>
                    <td data-th="第一次分數">
                      {{item.first_speak_score? item.first_speak_score: 0}}
                    </td>
                    <td data-th="口說分數" style="text-decoration: underline;" class="pointer" @click="goVoice(item.id)">
                      {{item.speak? item.speak: 0}}
                    </td>
                    <td data-th="學習次數">
                      {{item.finish_speak_count? item.finish_speak_count: 0}}
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <button type="button" style="width:100px" class="btn btn-danger m-1" @click="goLesson(item.id)">前往課程</button> -->
            </div>
          </div>
          <div v-if="recordInfo===[]" class="remind mt-5">
            <h3>期間並無學習紀錄</h3>
          </div>
          <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
        </div>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import Pagination from '@/components/Pagination.vue'
import api from '../../store/api'
export default {
  name: 'Info',
  data () {
    return {
      studentList: [],
      studentId: null,
      title: 'Info',
      recordInfo: null,
      range: [0,0],
      pageIndex: 1,
      pageCount: 0
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    lessonId () {
      return this.$route.params.lessonId
    }
  },
  watch: {
    studentId (val) {
      this.pageIndex = 1
      this.getRecordInfo(val)
    },
    range(val) {
      this.pageIndex = 1
      this.selectedChannel = 0
      this.getRecordInfo(this.studentId)
    },
    groupId(val) {
      this.getGroupStudent(val)
    }
  },
  mounted () {
    this.getStudentList()
  },
  methods: {
    async getStudentList() {
      //班級最大為300人
      const params = {
        page: this.pageIndex,
        pageSize: 300
      }
      const { data } = await api.get(`groups/${this.groupId}/students`, { params })
      this.studentList = data.data
      this.studentId = data.data[0].id
      this.page = data.pageIndex
      this.pageCount = data.pageCount
    },
    async getRecordInfo (id) {
      const params = {
        beginAt: this.range[0],
        endAt:  this.range[1],
        page: this.pageIndex,
        pageSize: this.pageSize,
        categoryId: this.selectedChannel,
      }
      const { data } = await api.get(`/records/students/${id}/learning_history`, { params })
      this.recordInfo = data.data
      this.pageCount = data.pageCount
    },
    goVoice (id) {
      this.$router.push({ name: 'VoiceRecordInfo', params: { groupId: this.groupId, lessonId: id, studentId: this.studentId } })
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getRecordInfo(this.studentId)
    },
    goTitlePage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    },
    async postReports () {
      try {
        const params = {
        beginAt: this.range[0],
        endAt:  this.range[1],
      }
        await api.get(`/reports/students/${this.studentId}/history`, { params })
        this.$swal({
          title: '報表計算完成後，將自動發送至您的信箱',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
      } catch (error) {
        if (error) {
          this.$swal({
            title: '目前報表功能異常，請聯絡管理者',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: '確定'
          })
        }
      }
    }
  },
  components: {
    Pagination,
    DatePicker
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/color.scss";
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .active {
    // color: red;
    font-weight: bolder;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
